export default __webpack_public_path__ + "static/media/start-enable.2a681915.svg";